/*!
 * CofCof.co — global theme behaviors
 * Vanilla port dos hooks React (IntersectionObserver de fade-in `.fi → .v`,
 * toggle do menu mobile, FAQ accordion). Sem dependências externas.
 * Visual e comportamento devem coincidir 1:1 com o projeto React original.
 */
(function () {
  'use strict';

  /* --- Fade-in scroll (.cofcof-fi → .cofcof-v) ---
     Reproduz o IntersectionObserver presente em MainLayout / Home / B2B / etc.
     threshold 0.12, rootMargin '0px 0px -40px 0px'. Idem ao React. */
  function initFadeIn() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.cofcof-fi').forEach(function (el) {
        el.classList.add('cofcof-v');
        el.querySelectorAll('img[loading="lazy"]').forEach(function (image) {
          image.loading = 'eager';
        });
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cofcof-v');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.cofcof-fi').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --- Motion editorial progressivo ---
     Usa Web Animations API para evitar dependência externa e animar apenas
     transform/opacity. O conteúdo permanece visível se JS falhar. */
  function initEditorialMotion() {
    if (!document.body.classList.contains('cofcof-design--editorial')) return;
    if (!Element.prototype.animate) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function reveal(element, delay) {
      element.classList.add('cofcof-useScroll-reveal');
      var animation = element.animate(
        [
          { opacity: 0.01, transform: 'translateY(18px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        {
          duration: 560,
          delay: delay || 0,
          easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)',
          fill: 'both'
        }
      );
      animation.finished.then(function () {
        element.classList.remove('cofcof-useScroll-reveal');
      }, function () {
        element.classList.remove('cofcof-useScroll-reveal');
      });
    }

    document.querySelectorAll(
      '.cofcof-pg-hero-badge, .cofcof-pg-hero-text > h1, .cofcof-pg-hero-text > p, .cofcof-pg-hero-cta, .cofcof-pg-hero-trust, .cofcof-hero-v2__eyebrow, .cofcof-hero-v2__copy, .cofcof-hero-v2__actions, .cofcof-hero-v2__proof, .cofcof-hero-v2__media'
    ).forEach(function (element, index) {
      reveal(element, index * 70);
    });

    if (!('IntersectionObserver' in window)) return;
    var useScrollObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target, 0);
          useScrollObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -8% 0px' }
    );

    document.querySelectorAll('.cofcof-main .cofcof-fi:not(.cofcof-pg-hero)').forEach(function (element) {
      useScrollObserver.observe(element);
    });
  }

  /* --- Mobile menu toggle (.cofcof-hb e .cofcof-mo) ---
     Espelha o `isMenuOpen` do Navbar.tsx. */
  function initMobileMenu() {
    var hb = document.querySelector('[data-cofcof-menu-toggle]');
    var mo = document.querySelector('[data-cofcof-menu]');
    if (!hb || !mo) return;
    var backdrop = document.querySelector('[data-cofcof-menu-backdrop]');
    var closeButton = mo.querySelector('[data-cofcof-menu-close]');
    var previousFocus = null;

    function getFocusable() {
      return Array.prototype.slice.call(
        mo.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return !element.hasAttribute('hidden') && element.getClientRects().length > 0;
      });
    }

    function setOpen(open) {
      if (open) previousFocus = document.activeElement;
      hb.classList.toggle('cofcof-o', open);
      mo.classList.toggle('cofcof-o', open);
      if (backdrop) backdrop.classList.toggle('cofcof-o', open);
      hb.setAttribute('aria-expanded', open ? 'true' : 'false');
      hb.setAttribute(
        'aria-label',
        open
          ? hb.getAttribute('data-label-close') || 'Fechar menu'
          : hb.getAttribute('data-label-open') || 'Abrir menu'
      );
      mo.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) mo.removeAttribute('inert');
      else mo.setAttribute('inert', '');
      document.body.style.overflow = open ? 'hidden' : '';

      if (open) {
        var searchPanel = document.querySelector('[data-cof-search-panel]');
        var searchToggle = document.querySelector('[data-cof-search-toggle]');
        if (searchPanel) searchPanel.hidden = true;
        if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
        window.requestAnimationFrame(function () {
          var focusable = getFocusable();
          if (focusable.length) focusable[0].focus();
        });
      } else if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    hb.addEventListener('click', function () {
      setOpen(!hb.classList.contains('cofcof-o'));
    });

    mo.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });

    if (closeButton) closeButton.addEventListener('click', function () { setOpen(false); });
    if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });

    document.addEventListener('keydown', function (event) {
      if (!hb.classList.contains('cofcof-o')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false);
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', function () {
      // Precisa acompanhar o CSS: o header atual troca para o menu em 1280px
      // (`.cofcof-mo`/`.cofcof-hb` em cofcof-global.css). Com um valor menor aqui,
      // um resize dentro da faixa fecharia o menu que ainda é a única navegação.
      if (window.getComputedStyle(hb).display === 'none') setOpen(false);
    });
  }

  /* --- Busca do header editorial --- */
  function initHeaderSearch() {
    var toggle = document.querySelector('[data-cof-search-toggle]');
    var panel = document.querySelector('[data-cof-search-panel]');
    if (!toggle || !panel) return;
    var close = panel.querySelector('[data-cof-search-close]');
    var input = panel.querySelector('input[type="search"]');

    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('data-cof-state', open ? 'open' : 'closed');
      if (open && input) window.requestAnimationFrame(function () { input.focus(); });
      if (!open) toggle.focus();
    }

    toggle.addEventListener('click', function () { setOpen(panel.hidden); });
    if (close) close.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault();
        setOpen(false);
      }
    });
  }

  /* --- Vídeo do hero: autoplay incondicional, com rede para a recusa do navegador --- */
  function initHeroVideo() {
    var video = document.querySelector('[data-cof-hero-video]');
    if (!video) return;

    /* ⚠️ `toggle` é OPCIONAL. O hero da home não tem mais botão (ver a
       justificativa em `sections/cofcof-home-hero.liquid`), e o ramo `editorial`
       tampouco. Se esta função voltar a abortar por falta de botão, ela leva
       junto o retry por gesto e o IntersectionObserver — e o retry é hoje a
       ÚNICA rede quando o navegador recusa `play()`. Há teste para isso. */
    var toggle = document.querySelector('[data-cof-hero-video-toggle]');
    var label = toggle ? toggle.querySelector('[data-cof-hero-video-label]') : null;

    /* O hero é em vídeo por decisão de identidade. O `src` vem no HTML e o
       autoplay nativo é o caminho principal — este JS é a REDE, não o motor.

       TRÊS travas foram removidas daqui, todas de propósito e nesta ordem:

       1 e 2. `saveData` e `effectiveType`, que desligavam o vídeo em `3g`. O
       Chrome reporta muito 4G brasileiro como `3g`, então a trava não protegia
       rede ruim — apagava o hero de quem entra pelo celular, em silêncio. Rede
       lenta segue coberta sem trava: o pôster de 21 KB cobre a primeira dobra
       inteira enquanto o MP4 baixa por baixo dele.

       3. `prefers-reduced-motion`, removida em 25/08 por decisão explícita do
       Tiago. Eu a havia mantido por acessibilidade e era exatamente ela que
       deixava o hero DELE parado com o botão à vista — o defeito que ele
       reportou três vezes era a minha decisão, não um bug. O custo aceito está
       declarado na seção e em `.claude/rules/frontend.md`. */
    var userPaused = false;
    var inViewport = true;
    var sourceAttached = video.hasAttribute('src');
    if (toggle) toggle.hidden = false;

    /* No caminho normal isto é no-op: o `src` vem no HTML. Fica como rede de
       segurança para markup que ainda use `data-src` (outra seção, tema antigo
       servido do cache de página da Shopify com o JS novo). */
    function attachSource() {
      if (sourceAttached) return true;
      var source = video.getAttribute('data-src');
      if (!source) return false;
      video.src = source;
      sourceAttached = true;
      return true;
    }

    /* No-op quando não há botão — que é o caso da home hoje. */
    function renderState() {
      if (!toggle) return;
      var isPlaying = !video.paused;
      toggle.setAttribute('data-cof-state', isPlaying ? 'playing' : 'paused');
      toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      if (label) label.textContent = isPlaying
        ? toggle.getAttribute('data-label-pause')
        : toggle.getAttribute('data-label-play');
    }

    /* `play()` pode ser RECUSADO pela política do navegador mesmo com o vídeo
       mudo: Modo de Baixo Consumo no iPhone, "Reprodução automática: Nunca" por
       site no Safari, extensão que bloqueia mídia. Até aqui a recusa era final —
       o pôster ficava congelado para sempre, e é exatamente isso que se lê como
       "o vídeo da home não inicia".

       O primeiro gesto do usuário libera a política em todo navegador. Então a
       recusa passa a armar UMA tentativa nova no próximo gesto, em vez de
       desistir. Sem gesto, nada acontece: continua o pôster, que já cobre a
       primeira dobra inteira. */
    var gestoArmado = false;
    var EVENTOS_DE_GESTO = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'];

    function tentarNoProximoGesto() {
      if (gestoArmado || userPaused) return;
      gestoArmado = true;
      function tentar() {
        EVENTOS_DE_GESTO.forEach(function (nome) { window.removeEventListener(nome, tentar, true); });
        gestoArmado = false;
        playVideo();
      }
      EVENTOS_DE_GESTO.forEach(function (nome) {
        window.addEventListener(nome, tentar, { capture: true, passive: true });
      });
    }

    function playVideo() {
      if (userPaused || !inViewport || document.hidden) return;
      if (!attachSource()) return;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(renderState).catch(function () {
          renderState();
          tentarNoProximoGesto();
        });
      } else renderState();
    }

    /* Segunda rede: o elemento avisando que já dá para tocar. Cobre a corrida em
       que o `play()` saiu antes de o navegador ter mídia suficiente e foi
       descartado em silêncio. `playVideo` recusa sozinho quando quem pausou foi
       o usuário, então isto não atropela a pausa. */
    video.addEventListener('canplay', function () {
      if (video.paused) playVideo();
    });

    /* Só existe quando há botão — hoje, nenhum ramo da home tem. Mantido para
       o caso de o controle voltar por decisão nova, não por descuido. */
    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) {
          userPaused = false;
          playVideo();
        } else {
          userPaused = true;
          video.pause();
          renderState();
        }
      });
    }

    video.addEventListener('play', renderState);
    video.addEventListener('pause', renderState);
    video.addEventListener('playing', function () {
      video.classList.add('cofcof-is-ready');
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inViewport = entry.isIntersecting;
          if (!inViewport) video.pause();
          else playVideo();
          renderState();
        });
      }, { threshold: 0.15 });
      observer.observe(video);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) video.pause();
      else playVideo();
      renderState();
    });

    /* Antes isto esperava o evento `load` e depois um `requestIdleCallback` de até
       2 s para SÓ ENTÃO anexar o `src` e começar a baixar 1 MB. Somando download,
       `canplay` e o fade, davam segundos de pôster parado na abertura da página —
       a queixa que originou esta mudança.

       Agora o `src` já vem no HTML e o autoplay nativo é quem começa. Esta chamada
       é só o segundo caminho, imediata, para o caso de o elemento ter ficado parado
       (política do navegador, corrida de `canplay`). O ganho de LCP continua vindo
       de onde sempre veio: do pôster, não de adiar o vídeo. */
    playVideo();

    renderState();
  }

  /* --- Catálogo: comunica a navegação server-rendered sem criar dependência de JS. --- */
  function initCollectionToolbar() {
    document.querySelectorAll('[data-cof-collection-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var loading = form.querySelector('[data-cof-collection-loading]');
        form.setAttribute('aria-busy', 'true');
        if (loading) loading.hidden = false;
      });
    });
  }

  /* --- FAQ accordion (.cofcof-fq-i / .cofcof-fq-q) ---
     Espelha `openFaq` do Contact.tsx — apenas um item aberto por vez. */
  function initFaq() {
    document.querySelectorAll('[data-cofcof-faq]').forEach(function (faq) {
      var items = faq.querySelectorAll('.cofcof-fq-i');
      items.forEach(function (item) {
        var trigger = item.querySelector('.cofcof-fq-q');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('cofcof-o');
          items.forEach(function (other) { other.classList.remove('cofcof-o'); });
          if (!isOpen) item.classList.add('cofcof-o');
        });
      });
    });
  }

  /* --- Scroll to top on page change (Shopify navega via full-page, então
       só aplica quando user clica em link com data-cofcof-scroll-top). */
  function initScrollTop() {
    document.querySelectorAll('[data-cofcof-scroll-top]').forEach(function (link) {
      link.addEventListener('click', function () {
        try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
      });
    });
  }

  /* --- Smooth scroll para hash anchors (#mapa-origem, #exportacao, etc.) --- */
  function initHashScroll() {
    if (!window.location.hash) return;
    var id = window.location.hash.substring(1);
    setTimeout(function () {
      var el = document.getElementById(id);
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.scrollY - 80;
      try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, top); }
    }, 500);
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    initFadeIn();
    initEditorialMotion();
    initMobileMenu();
    initHeaderSearch();
    initHeroVideo();
    initCollectionToolbar();
    initFaq();
    initScrollTop();
    initHashScroll();
  });

  /* ----------------------------------------------------------
     AUD-05 — pausa das esteiras de texto (WCAG 2.2.2)
     ----------------------------------------------------------
     O botão nasce com `hidden` no snippet: sem este script ele não
     controlaria nada, e um controle inerte é ruído para quem navega por
     teclado. Só aqui ele passa a existir.

     Pausa por classe, nunca por estilo inline, para o `:hover` do CSS
     continuar valendo. E `animation-play-state` em vez de `animation: none`,
     para a esteira retomar de onde parou em vez de saltar para o início.
     ---------------------------------------------------------- */
  function initTickerToggle() {
    var botoes = document.querySelectorAll('[data-ticker-toggle]');
    Array.prototype.forEach.call(botoes, function (botao) {
      var faixa = botao.closest('.cofcof-tk');
      var trilho = faixa && faixa.querySelector('.cofcof-tk-i');
      if (!trilho) return;

      var rotulo = botao.querySelector('[data-ticker-toggle-label]');
      var iconePausar = botao.querySelector('[data-ticker-icone-pausar]');
      var iconeRetomar = botao.querySelector('[data-ticker-icone-retomar]');
      var textoPausar = rotulo ? rotulo.getAttribute('data-rotulo-pausar') : 'Pausar o movimento';
      var textoRetomar = rotulo ? rotulo.getAttribute('data-rotulo-retomar') : 'Retomar o movimento';

      botao.hidden = false;
      botao.setAttribute('aria-label', textoPausar);

      botao.addEventListener('click', function () {
        var parando = !trilho.classList.contains('cofcof-tk-i--parada');
        trilho.classList.toggle('cofcof-tk-i--parada', parando);
        botao.setAttribute('aria-pressed', parando ? 'true' : 'false');
        var texto = parando ? textoRetomar : textoPausar;
        if (rotulo) rotulo.textContent = texto;
        botao.setAttribute('aria-label', texto);
        if (iconePausar) iconePausar.hidden = parando;
        if (iconeRetomar) iconeRetomar.hidden = !parando;
      });
    });
  }
  initTickerToggle();

  /* Expor namespace mínimo (sem poluir window) */
  window.Cofcof = window.Cofcof || {};
  window.Cofcof.refreshFadeIn = initFadeIn;
})();
